import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import AvisoLimitacaoArquivos from 'Static/images/aviso-limitacao-arquivos.png';
import { Icon } from 'Components/UI';
import styles from './AvisoTamanhoEQuantidadeArquivos.module.scss';

interface IAvisoTamanhoEQuantidadeArquivos {
  visible?: boolean;
  onConfirm?: () => void;
}

const AvisoTamanhoEQuantidadeArquivos: FC<IAvisoTamanhoEQuantidadeArquivos> = ({ visible, onConfirm }) => {
  const { t } = useTranslation('listagemArquivos');

  const buttons = (
    <div>
      <Button className={styles['button']} type='primary' height={37} onClick={onConfirm}>
        {t('avisoUpload.understood')}
      </Button>
    </div>
  );

  return (
    <Modal
      footerButtons={buttons}
      visible={visible}
      width={798}>
      <div className={styles['wrapper']}>
        <img src={AvisoLimitacaoArquivos} className={styles['imageWrapper']} />
        <div className={styles['contentWrapper']}>
          <h2>{t('avisoUpload.attention')}</h2>
          <p>{t('avisoUpload.limitMessage')}</p>
          <div>
            <ul>
              <li><Icon icon={'arquivoTxt'} size={'xs'} customColor={'#bec2c6'} ></Icon> <label>{t('avisoUpload.maxFiles')}</label></li>
              <li><Icon icon={'estrela'} size={'xs'} customColor={'#bec2c6'} ></Icon> <label>{t('avisoUpload.maxSize')}</label></li>
              <li style={{ marginBottom: 14 }}>&nbsp;</li>
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AvisoTamanhoEQuantidadeArquivos;
